import { UpdateCouponInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateCouponInputSchema: z.ZodType<UpdateCouponInput> = z.object({
  active: z.boolean(),
});
